module.exports = __webpack_public_path__ + "static/media/error.f7ea6e19.svg";